import styled, { css } from 'styled-components';
import { getSpacingToken, getTextTokenPreset } from '@optimus-web/common';
import { Button, Icon } from '@optimus-web/core';
import {
    COLOR_LIGHT_GRAY,
    COLOR_WHITE,
    COLOR_ACTIONABLE_LIGHT,
    Z_INDEX_OVERLAY,
} from '../../../components/commander-ui/constants';

export const ContentWrapper = styled.div`
    width: 574px;
    max-width: 95vw;
    background-color: ${COLOR_WHITE};
    height: 100%;
`;

export const LabelElement = styled.div`
    padding: ${getSpacingToken('0')} ${getSpacingToken('50')}px ${getSpacingToken('0')} ${getSpacingToken('200')}px;
    height: 48px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${COLOR_LIGHT_GRAY};
    position: sticky;
    top: 0;
    background-color: ${COLOR_WHITE};
    z-index: ${Z_INDEX_OVERLAY};
`;

export const NotificationWrapper = styled.div<{ highlight: boolean }>`
    padding: ${getSpacingToken('0')} ${getSpacingToken('50')}px ${getSpacingToken('0')} ${getSpacingToken('0')};
    display: flex;
    justify-content: space-between;
    ${({ highlight }) =>
        highlight &&
        css`
            background-color: ${COLOR_ACTIONABLE_LIGHT};
        `}
`;

export const NotificationContentWrapper = styled.div`
    padding: ${getSpacingToken('100')}px ${getSpacingToken('0')} ${getSpacingToken('100')}px ${getSpacingToken('200')}px;
    flex: 1 1;
    overflow: auto;
`;

export const NotificationLoadButtonWrapper = styled(NotificationContentWrapper)<{ hide?: boolean }>`
    cursor: default;
    text-align: center;
    ${({ hide }) =>
        hide &&
        css`
            display: none;
        `}
`;

export const LabelIcon = styled(Icon)`
    color: inherit;
    font-size: inherit;
    margin-right: ${getSpacingToken('50')}px;
`;

export const NotificationLabel = styled.span`
    display: flex;
    align-items: center;
    ${getTextTokenPreset('bodyMedium')};
    margin-bottom: ${getSpacingToken('50')}px;

    ${(props) =>
        (props as $TSFixMe).highlighted &&
        css`
            ${getTextTokenPreset('bodyMediumStrong')};
        `}
`;

export const NotificationContentElement = styled.div`
    display: flex;
    word-break: break-word;

    ${(props) =>
        (props as $TSFixMe).highlighted &&
        css`
            ${getTextTokenPreset('bodyMediumStrong')};
        `}
`;

export const MessageWrapperElement = styled.div`
    line-height: 1.5em;
    max-height: 4.5em;
    overflow: hidden;
`;

export const ExportWrapperElement = styled.div`
    display: flex;
    flex-direction: column;
`;

export const NoContentElement = styled.div`
    padding: ${getSpacingToken('200')}px;
    text-align: center;
`;

export const MessageTagWrapper = styled.span`
    margin-right: ${getSpacingToken('100')}px;
`;

export const NoWrapTextButton = styled(Button).attrs({ variant: 'ghost' })`
    white-space: nowrap;
`;
